<template>
  <div style="padding: 1em;">
    <ion-button fill="outline" @click="addCategory()">Add new category</ion-button>
    <ion-button style="float: right;" @click="cancel()" fill="clear">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
    <table style="margin-top: 1em;">
      <thead>
        <tr>
          <th>Title</th>
          <th>Parent</th>
          <th style="width: 60px;"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(c, idx) in categories" :key="idx">
          <td>{{c.title}}</td>
          <td>{{parentValue(c.parent)}}</td>
          <td class="table-actions">
            <ion-icon name="create" @click="edit(c)"></ion-icon>&nbsp;&nbsp;
            <ion-icon style="color: red;" name="trash" @click="deleteCat(c.id)"></ion-icon>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="popupCreate" style="display:none;" v-if="popupContent">
      <div style="padding: 0.5em 1em;">
        <h4>Add new category</h4>
        <ion-list>
          <ion-item>
            <ion-label>Title</ion-label>
            <ion-input v-ion-model="label"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label>Parent</ion-label>
            <v-select label="label" :value="selectValue" @input="setSelected" :options="options" :searchable="false" :clearable="false" :appendToBody="true">
              <template #option="{ label }">
                <p style="margin: 0">{{ label }}</p>
              </template>
            </v-select>
          </ion-item>
        </ion-list>

        <div style="position: absolute; bottom: 0.5em; right: 0.5em;">
          <ion-button @click="cancel">Cancel</ion-button>
          <ion-button @click="submit">Submit</ion-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../../config.js";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  data() {
    return {
      popupContent: true,
      options: [
        {label: 'Political Law', value: 2},
        {label: 'Labor Law', value: 3},
        {label: 'Civil Law', value: 4},
        {label: 'Taxation Law', value: 5},
        {label: 'Commercial Law', value: 6},
        {label: 'Criminal Law', value: 7},
        {label: 'Remedial Law', value: 8},
        {label: 'Legal Ethics', value: 9},
        {label: 'Others', value: 10}
      ],
      category: null,
      label: "",
      current: null,
      categories: []
    }
  },
  computed: {
    selectValue() {
      if(this.category) {
        const idx = this.options.findIndex(x => x.value === this.category);
        return this.options[idx];
      }
      return null;
    }
  },
  methods: {
    addCategory() {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(null, {
          template: "popupCreate",
          cssClass: "medium-width-popup",
          translucent: true
        });
      }, 200);
    },
    async setSelected(value) {
      if(value) {
        this.category = value.value;
      } else {
        this.category = null;
      }
    },
    async edit(cat) {
      this.label = cat.title;
      this.category = cat.parent;
      this.current = cat.id;
      this.addCategory();
    },
    clearSelected() {
      this.label = "";
      this.category = null;
      this.current = null;
    },
    async submit() {
      if(!this.label) {
          this.$ionic.showToast("Please provide a label.", {
          position: "bottom"
        });
        return;
      }

      // if(!this.category) {
      //   this.$ionic.showToast("Please select parent category from the dropdown.", {
      //     position: "bottom"
      //   });
      //   return;
      // }

      const url = this.current ? config.api.url + "/categories/" + this.current : config.api.url + "/categories";
      const method = this.current ? "PUT":"POST";

      const res = await this.$http({
        method: method,
        url: url,
        data: {parent: this.category, title: this.label},
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      if(res) {
        if(res.data) {
          this.getCategories();
          this.$ionic.dismissPopover();
          this.clearSelected();
          return;
        }
      }

      this.$ionic.showToast("Something went wrong.", {
        position: "bottom"
      });
    },
    cancel() {
      this.$ionic.dismissPopover();
      this.clearSelected();
    },
    async deleteCat(id) {
      const res = await this.$http({
        method: "DELETE",
        url: config.api.url + "/categories/" + id,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

       this.getCategories();
    },
    async getCategories() {
      const res = await this.$http({
        method: "GET",
        url: config.api.url + "/categories",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      if(res) {
        if(res.data) {
          if(res.data.result.length > 0) {
            this.categories = res.data.result;
          }
        }
      }
    },
    parentValue(parent) {
      if(parent) {
        const idx = this.options.findIndex(x => x.value === parent);
        if(!this.options[idx]) {
          return null;
        }
        return this.options[idx].label;
      }
    }
  },
   components: {
    "v-select": vSelect
  },
  mounted() {
    this.getCategories();
  }
}
</script>
<style scoped>
table {
  width: 100%;
}
th {
  text-align: left;
  border-bottom: 2px solid #000;
}

th, td {
  padding: 0.5em 0.25em;
}

tbody tr:nth-child(even){
  background-color: #dddddd;
}

.table-actions ion-icon{
  cursor: pointer;
  font-size: 1.3em;
}

.mode-dark tbody tr:nth-child(even) {
  background-color: #424242;
}

.mode-dark tbody tr:nth-child(odd) {
  background-color: #292929;
}
</style>